import { useMemo } from "react";
import scrollparent from "scrollparent";

export function useScrollableParent(element: Element | null) {
  return useMemo(() => {
    return element ? scrollparent(element as HTMLElement | SVGElement) : null;
  }, [element]);
}
